import { useMemo } from "react";

const BULBS = ["#FF4D4D", "#F0C971", "#4ADE80", "#00F0FF"];

const Sleigh = () => (
  <svg viewBox="0 0 240 90" fill="none" className="w-full h-auto">
    {/* reindeer */}
    <g>
      <ellipse cx="205" cy="52" rx="16" ry="10" fill="#A9743F" />
      <path d="M218 46 L228 32 L233 34 L226 48 Z" fill="#A9743F" />
      <circle cx="232" cy="31" r="6" fill="#A9743F" />
      <path d="M230 25 L224 14 M230 25 L236 13 M233 25 L240 16" stroke="#E8D9C0" strokeWidth="2.4" strokeLinecap="round" />
      <path d="M196 60 L193 78 M204 61 L202 78 M212 60 L214 78 M218 58 L221 76" stroke="#A9743F" strokeWidth="3.4" strokeLinecap="round" />
      <circle cx="238" cy="30" r="2.6" fill="#FF3B3B" />
    </g>
    {/* rope */}
    <path d="M188 52 C 176 48, 160 50, 150 54" stroke="#F0C971" strokeWidth="2" />
    {/* santa */}
    <g>
      <ellipse cx="94" cy="34" rx="10" ry="13" fill="#8A1F1F" transform="rotate(-18 94 34)" />
      <circle cx="114" cy="40" r="11" fill="#D4242A" />
      <ellipse cx="114" cy="30" rx="7" ry="4.5" fill="#ffffff" />
      <circle cx="114" cy="25" r="7" fill="#F2C9A0" />
      <path d="M106 23 Q114 6 124 20 Q120 22 114 21 Q110 22 106 23 Z" fill="#D4242A" />
      <circle cx="125" cy="19" r="3" fill="#ffffff" />
    </g>
    {/* sleigh */}
    <path d="M60 52 Q58 70 80 72 L136 72 Q152 72 152 58 L146 52 Z" fill="#D4242A" />
    <path d="M60 52 Q58 70 80 72 L136 72 Q152 72 152 58" stroke="#F0C971" strokeWidth="2.5" fill="none" />
    <path d="M52 80 Q50 88 64 86 L150 82 Q164 81 162 74" stroke="#F0C971" strokeWidth="3" strokeLinecap="round" fill="none" />
    <path d="M70 73 L68 82 M140 73 L142 81" stroke="#F0C971" strokeWidth="2.5" />
  </svg>
);

export const ChristmasFX = () => {
  const flakes = useMemo(
    () =>
      Array.from({ length: 45 }, () => ({
        left: Math.random() * 100,
        size: 2 + Math.random() * 4,
        duration: 9 + Math.random() * 9,
        delay: -Math.random() * 18,
        drift: (Math.random() - 0.5) * 12,
        opacity: 0.35 + Math.random() * 0.55,
      })),
    []
  );

  return (
    <>
      <div className="xmas-snow" aria-hidden="true" data-testid="xmas-snow">
        {flakes.map((f, i) => (
          <span
            key={i}
            className="xmas-flake"
            style={{
              left: `${f.left}%`,
              width: f.size,
              height: f.size,
              opacity: f.opacity,
              animationDuration: `${f.duration}s`,
              animationDelay: `${f.delay}s`,
              "--drift": `${f.drift}vw`,
            }}
          />
        ))}
      </div>
      <div className="xmas-sleigh" aria-hidden="true" data-testid="xmas-sleigh">
        <div className="xmas-sleigh-bob">
          <Sleigh />
        </div>
      </div>
      <div className="xmas-garland" aria-hidden="true">
        {Array.from({ length: 26 }, (_, i) => (
          <span
            key={i}
            className="xmas-bulb"
            style={{
              background: BULBS[i % 4],
              boxShadow: `0 0 8px 2px ${BULBS[i % 4]}55`,
              animationDelay: `${(i % 6) * 0.35}s`,
            }}
          />
        ))}
      </div>
    </>
  );
};
